import { combineReducers } from 'redux';
import {activeUserReducer} from "./activeUser/reducer";
import { projectReducer } from './project/reducer';
import { systemReducer } from './system/reducer';
import { brainGameReducer } from './brainGame/reducer';

const reducers = combineReducers({
    activeUser: activeUserReducer,
    project: projectReducer,
    brainGame: brainGameReducer,
    system: systemReducer,
});

export { reducers };

export type RootState = ReturnType<typeof reducers>;
